import { AES } from 'crypto-js';

const secret = `${process.env.REACT_APP_GLOBAL_SECRET}`;

export const hash = (data: unknown): string => {
    return AES.encrypt(JSON.stringify(data), secret).toString();
};

export const unhash = (hash: string): unknown => {
    return JSON.parse(AES.decrypt(hash, secret).toString(CryptoJS.enc.Utf8));
};

export const hashForUrl = (data: unknown): string => {
    return encodeURIComponent(hash(data));
};

export const unhashFromUrl = (hash: string): unknown => {
    return unhash(decodeURIComponent(hash));
};
